import {
  STORE_CLASS_DIAGNOSTIC_REQUEST,
  STORE_CLASS_DIAGNOSTIC_SUCCESS,
  STORE_CLASS_DIAGNOSTIC_ERROR,
  LIST_CLASS_DIAGNOSTICS_REQUEST,
  LIST_CLASS_DIAGNOSTICS_SUCCESS,
  LIST_CLASS_DIAGNOSTICS_ERROR,
  GET_CLASS_DIAGNOSTIC_DETAIL_REQUEST,
  GET_CLASS_DIAGNOSTIC_DETAIL_SUCCESS,
  GET_CLASS_DIAGNOSTIC_DETAIL_ERROR,
  DELETE_CLASS_DIAGNOSTIC_REQUEST,
  DELETE_CLASS_DIAGNOSTIC_SUCCESS,
  DELETE_CLASS_DIAGNOSTIC_ERROR,
} from '../actions';

export const storeClassDiagnosticRequest = (data) => ({
  type: STORE_CLASS_DIAGNOSTIC_REQUEST,
  payload: data,
});
export const storeClassDiagnosticSuccess = (data) => ({
  type: STORE_CLASS_DIAGNOSTIC_SUCCESS,
  payload: data,
});
export const storeClassDiagnosticError = (message) => ({
  type: STORE_CLASS_DIAGNOSTIC_ERROR,
  payload: { message },
});

export const listClassDiagnosticsRequest = (classId) => ({
  type: LIST_CLASS_DIAGNOSTICS_REQUEST,
  payload: { classId },
});
export const listClassDiagnosticsSuccess = (data) => ({
  type: LIST_CLASS_DIAGNOSTICS_SUCCESS,
  payload: data,
});
export const listClassDiagnosticsError = (message) => ({
  type: LIST_CLASS_DIAGNOSTICS_ERROR,
  payload: { message },
});

export const getClassDiagnosticDetailRequest = (classId, diagnosticId, cycleIs) => ({
  type: GET_CLASS_DIAGNOSTIC_DETAIL_REQUEST,
  payload: { classId, diagnosticId, cycleIs },
});
export const getClassDiagnosticDetailSuccess = (data) => ({
  type: GET_CLASS_DIAGNOSTIC_DETAIL_SUCCESS,
  payload: data,
});
export const getClassDiagnosticDetailError = (message) => ({
  type: GET_CLASS_DIAGNOSTIC_DETAIL_ERROR,
  payload: { message },
});

export const deleteClassDiagnosticRequest = (id) => ({
  type: DELETE_CLASS_DIAGNOSTIC_REQUEST,
  payload: { id },
});
export const deleteClassDiagnosticSuccess = (id) => ({
  type: DELETE_CLASS_DIAGNOSTIC_SUCCESS,
  payload: { id },
});
export const deleteClassDiagnosticError = (message) => ({
  type: DELETE_CLASS_DIAGNOSTIC_ERROR,
  payload: { message },
});
